import { Component, ElementRef, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { of as observableOf, Observable, of, Subscription, throwError } from 'rxjs';
import { FlatTreeControl } from '@angular/cdk/tree';
import { files } from '../../_models/example-data';
import { ProjectService } from '../../_services/project.service';
import { TestService } from '../../_services/test.service';
import { ToastrService } from 'ngx-toastr';
import { beatBlipSubscriptionConsts } from '../../consts/beatBlipSubscriptionConsts';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators, UntypedFormControl, UntypedFormArray } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, find, switchMap, elementAt } from 'rxjs/operators';
import { UserMgmtService } from '../../_services/user-mgmt.service';
import { UserService } from '../../_services/user.service';
import { UserRestrictions } from '../../_models/userRestriction';
import { UserTab } from '../../_models/UserTab';
import { ProjectData } from 'src/app/_models/project-data';
import { Pipe, PipeTransform } from '@angular/core';
import { ConfirmationDialogService } from '../test-step/confirmation-dialog.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material/dialog';
import { UpdateFormComponent } from './update-form/update-form.component';
import { countBy } from 'lodash';
// import { MatMenuTrigger, PageEvent } from '@angular/material';
import _ from 'lodash';
import { environment } from 'src/environments/environment';
import { MatMenuTrigger } from '@angular/material/menu';
import { SettingService } from 'src/app/_services/setting.service';
import { SpinnerService } from 'src/app/_services/spinner.service';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from "src/app/_services/home.service";
import { Modal } from 'bootstrap';

@Component({
  selector: 'app-test-case',
  templateUrl: './test-case.component.html',
  styleUrls: ['./test-case.component.scss']
})

export class TestCaseComponent implements OnInit {
  @ViewChild('editModal', { static: true }) editModal: TemplateRef<any>;
  // @ViewChild('myModal',{static: false}) myModal: { nativeElement: { className: string; }; }; 
  @ViewChild('cancelmodal', null) cancelmodal: ElementRef;
  @ViewChild('cancelmodalForIncludeTestSuite', null) cancelmodalForIncludeTestSuite: ElementRef;
  @ViewChild('cancelmodalForPasteCase', null) cancelmodalForPasteCase: ElementRef;
  @ViewChild('dissociation', null) dissociation: ElementRef;
  @ViewChild('association', null) association: ElementRef; //closeMoveModal
  @ViewChild('closeMoveModal', null) closeMoveModal: ElementRef; //cancelSeleniumDataScreen
  @ViewChild('closeMovePreStepModal', null) closeMovePreStepModal: ElementRef;
  @ViewChild('cancelSeleniumDataScreen', null) cancelSeleniumDataScreen: ElementRef; 
  @ViewChild('cancelmodalforcomment', null) cancelmodalforcomment: ElementRef; 
  @ViewChildren("checkboxes") checkboxes: QueryList<ElementRef>;
  @ViewChildren("checkboxesPre") checkboxesPre: QueryList<ElementRef>;
  @ViewChildren("includedSuit") includedSuitCheckboxes: QueryList<ElementRef>;
  @ViewChildren("includeNewSuit") includeNewSuitCheckboxes: QueryList<ElementRef>;
  

  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'Case',
    data: undefined,
  }
  projectId: string;
  testId: string;
  url: string;
  testCassedata: any;
  testCaseCreateForm: UntypedFormGroup;
  submitted: boolean = false;
  testCaseStep: any;
  testCaseUpdateForm: UntypedFormGroup;
  name;
  titleForUpdate: any;
  testCaseIdForUpdate: any;
  dataLabelsForUpdate: any;
  commentForUpdate: any;
  projectData: Object;
  form: UntypedFormGroup;
  form1: UntypedFormGroup;
  form2: UntypedFormGroup;
  form3: UntypedFormGroup;
  pasteForm: UntypedFormGroup;
  testCaseIdFormArray: any = [];
  indexFormArray: UntypedFormArray;
  indexFormArray1: UntypedFormArray;
  indexFormArray2: UntypedFormArray;
  indexFormArray3: UntypedFormArray;
  pasteFormArray:  UntypedFormArray;
  CaseMoveEnable: boolean;
  moveEnable: boolean;
  Title: any;
  moveTestCaseForm: UntypedFormGroup;
  moveIndex: any;
  orderIndex: string;
  sourceIndex: any;
  enableAssociation: boolean = false;
  textData=[];
  public searchString: string;
  testDataForAssociation: any;
  enableDisassosciationButton: any;
  disassociationButton: boolean = true;
  associationButton: boolean = true;
  compareName: string = '';
  ObjectForAssociation: any;
  activeState = '';
  subscription2: Subscription;
  subscription: Subscription;
  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  testCaseId;
  selectedTestCaseId;
  testSuiteFileData: any = [];
  tableData: any = [];
  unCheckTestSuite: boolean = false;
  searchString1: string = "";
  testTreedata: any = [];
  testTreedataDir: any = [];
  projectTreedata: any = [];
  includeTestCaseList: any = [];
  suiteData: Object;
  testStep: any = [];
  testStepAtSelectedIndex: { active: string; commandName: string; comment: string; debug: string; elementKey: string; evaluatedMetaValue: string; maskedData: string; pageName: string; parameters: string; result: { startTime: string; endTime: string; duration: string; resultState: {}; aggrResultState: {}; }; runState: string; testData: string; type: string; };
  result: any[];
  stepsTobeDelete: any;
  initiateDelTestStep: any;
  enableMultiAssociation: boolean = false;
  textDataId: any;
  enableMultiAssociationButton: boolean = false;
  showAssociationButton: boolean = true;
  showDissociationButton: boolean = false;
  flag: any;
  textDataName: any;
  textDataSettingType: any;
  testIdArray: any;
  enableMultiDissociationButton: boolean = false;
  associatedTestCaseData: any;
  selectedAllFlag: boolean = false;
  enableMultiDelete: boolean = true;
  selectedTestIdArray: any;
  isEnabled: boolean = false;
  isPasteEnabled:boolean = false;
  list: any;
  executionIteration = 1;
  testStepdata: Object;
  settingNameForAssociation: any;
  nameForAssociation: any;
  seleniumFile: any;
  seleniumFileName: any;
  enableseleniumButton: boolean=false;
  testStepIndexForInsert: any;
  stepIndexForInsertComment: any;
  valueForUpdate: any;
  typeCheck: any;
  formObj: any;
  enableBUtton: boolean;
  pathContextClick: any;
  testDataForManangeLocator: any;
  testStepArray:any;
  enablePaste: boolean;
  enableCopyCheck: boolean;
  enableCopy: boolean;
  enableCut: boolean;
  cutTestStepArray: { list: any; };
  enableCutPaste: boolean;
  StepMoveEnable: boolean;
  sourcePreStepIndex: any;
  movePreStepIndex: any;
  moveTestStepForm: UntypedFormGroup;
  orderPreStepsIndex: number;
  enbleTestCase: boolean = true;
  projectType: any;
  sPath: any;
  testCaseMultiCheck : boolean = false;
  preStepsMultiCheck : boolean = false;
  incTestSuiteMultiCheck : boolean = false;

  taskPerpageitem = beatBlipSubscriptionConsts.perpageitem;
  taskCurrentPage : number = 1;
  taskSelectedPage: any;

  preConditionsPerpageitem = beatBlipSubscriptionConsts.perpageitem;
  preConditionsCurrentPage : number = 1;
  preConditionsSelectedPage: any;

  IncProcessPerpageitem = beatBlipSubscriptionConsts.perpageitem;
  IncProcessCurrentPage : number = 1;
  IncProcessSelectedPage: any;
  selectedIncludeSuiteIdArray: any;
  cardView: boolean;
  regexStr = '^[a-zA-Z0-9_{}[]() ]+$'
  private options = {
    headers: new HttpHeaders().set("Content-Type", "application/json"),
  };
  DataForPaste: any;
  testIdForPaste: any;
  allSuiteList: any[];
  cutDataForPaste: any;
  enableCutFlag: boolean = false;
  currentUrl: string;
  previousUrl: any =[];
  urlName: any;
  projectSubscription: Subscription;
  breadCrumb: any;
  agentCheck: boolean;
   ADOCheck =  localStorage.getItem('isADOEnabled') == 'true' ? true : false;
  testCaseCheck: any;
  checkFlagForAss: boolean;
  selectedCase: any;

  constructor(
    private testCase: TestService,
    private route: ActivatedRoute,
    private project: ProjectService,
    private toastrService: ToastrService,
    private cookieService: CookieService,
    private http: HttpClient,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private usermgmt: UserMgmtService,
    private confirmationDialogService: ConfirmationDialogService,
    private setting : SettingService,
    private router: Router,
    private modalService: NgbModal,
    private dialog: MatDialog,
    private spinner: SpinnerService,
    private urlService: UrlService,
    private memoryService: MemoryService,
    private userManagement: UserMgmtService,
    private homeService: HomeService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.flag = 0;
    this.spinner.isLoading.next(true);
    this.subscription2 = this.project.getTestData().subscribe(
      (data) => {
        this.initTestCaseData();
        //console.log(data);
      }
    )
    this.subscription = this.project.getUpdateData().subscribe(
      (data) => {
        this.initTestCaseData();
        //console.log(data);
      }
    )
    this.url = environment.baseUrl;
    this.form = this.formBuilder.group({
      checkArray: this.formBuilder.array([])
    })

    this.form1 = this.formBuilder.group({
      checkArray: this.formBuilder.array([])
    })
    this.form2 = this.formBuilder.group({
      checkArray: this.formBuilder.array([])
    })
    this.form3 = this.formBuilder.group({
      checkArray3: this.formBuilder.array([])
    })
    this.pasteForm = this.formBuilder.group({
      checkArray: this.formBuilder.array([])
    })
    
  }
  @ViewChildren(MatMenuTrigger) trigger: QueryList<MatMenuTrigger>;

  @ViewChild(MatMenuTrigger, null)
  contextMenu: MatMenuTrigger;
  @ViewChild(MatMenuTrigger, null)
  contextMenu1: MatMenuTrigger;

  contextMenuPosition = { x: '0px', y: '0px' };
  contextMenu1Position = { x: '0px', y: '0px' };
  ngOnInit() {
    this.testCase.setStepForEdit(undefined)
    this.memoryService.getAgentCheck().subscribe(
      (response)=>{
        this.agentCheck = response;
       
      }
    )
    this.loadUser();
    this.route.paramMap.subscribe(
      params => {
        //console.log(params)
        this.projectId = params.get('pid');
        this.testId = params.get('tid');
        if(!this.agentCheck){
          this.breadCrumb = JSON.parse(localStorage.getItem('breadCrumb'))
        }
       else{
        this.memoryService.getBreadCrumb().subscribe(
          (breadCrumb)=>{
            this.breadCrumb = breadCrumb;
          }
        )
       }
      
        if(!this.agentCheck){
          if (localStorage.getItem('copiedTestStep')) {
            this.enablePaste = true;
            this.enableCopyCheck = true;
            ////'paste',this.enablePaste);
          }
          if (localStorage.getItem('cutTestStepData')) {
            this.enableCutPaste = true;
          }
        }
        else{
          this.memoryService.getCopiedObj().subscribe(
            (copied)=>{
              if(copied.length){
                this.enablePaste = true;
                this.enableCopyCheck = true;
              }
            }
          )
          this.memoryService.getCutObj().subscribe(
            (cut)=>{
              if(cut.length){
                this.enableCutPaste = true;
              }
            }
          )
        }
        this.moveTestStepForm = this.formBuilder.group({
          orderIndex:['',Validators.required]
        })

        this.initTestCaseData();
      }

    );

    this.getProjectName();
    this.loadForm();
    // this.testCase.getView().subscribe((data)=>{
    //   this.cardView = data;
    // })
    var groupedActionData;
      this.testCase.getGroupedAction().subscribe(
        (data) => {
        groupedActionData = data;
          localStorage.setItem('groupedActionData', JSON.stringify(groupedActionData))
          // console.log(this.groupedActionData);
          // this.loadActionsMetaData();
        }
        )
   
  }

  loadUser()
  {
    if(!JSON.parse(localStorage.getItem('currentUser'))){
      this.userService.getUser().subscribe((res: any)=>{
        this.cardView = res.isCardView == 'true' ? true : false;
      })
    }
    else{
      var resp = JSON.parse(localStorage.getItem('currentUser'));
      this.cardView = resp.isCardView == 'true' ? true : false;
    }
  
  }
  addBranch(){
    
   var objectToUpdate = {
    "branch": [
        {
            "branch": "HuLoop",
            "description": "This is branch two"
        },
        {
            "branch": "HuLoop2",
            "description": "This is branch two"
        }
    ]
}
   this.testCase.createBranch(this.projectId,this.testId,objectToUpdate).subscribe(
    (data)=>{
      console.log('branch created');
      this.toastrService.clear();
      this.toastrService.success('by default 2 branch is created')
      this.initTestCaseData()
    }
   )
  }
  initTestCaseData() {
    this.getDefaultTextData();
    this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testSuiteData/' + this.projectId + '/' + this.testId).
      subscribe(
        (data) => {
          // this.testCassedata = {};
          try {
            localStorage.setItem('testCassedata',JSON.stringify(data));
          } catch (error) {
            console.log('unable to save project data to local');
            
          }
          
          this.testCassedata = data;
          // this.spinner.isLoading.next(true);
          if (!this.testCassedata['testCaseData']) {
            this.testCassedata['testCaseData'] = [];
          }
          var filterCaseData = this.testCassedata.testCaseData.filter((f) => f.isDeleted === "false" && f.branch[0]=='false');
          if(filterCaseData){
            this.testCassedata['testCaseData'] = filterCaseData; 
          }
          for(let i=0;i<  this.testCassedata['testCaseData'].length;i++){
            this.testCassedata['testCaseData'][i].caseIndex = i;
          }
          
          this.includedTestCases();
          localStorage.removeItem('testCassedata');
          this.getTestSuiteData();
          this.incTestSuiteMultiCheck = false;
          this.testCaseMultiCheck  = false;
          this.preStepsMultiCheck  = false;
          this.currentUrl =  this.router.url;
          this.urlName = this.testCassedata.title;
          this.previousUrl= this.urlService.captureUrl(this.currentUrl,this.urlName,'testCase');
          if(!this.agentCheck){
            localStorage.setItem('urlHistory', JSON.stringify(this.previousUrl));
            this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
          }
          else{
            this.memoryService.setUrlHistory(this.previousUrl)
            this.memoryService.getUrlHistory().subscribe(
              (urlHistory) => {
                this.previousUrl = urlHistory;
              }
            )
          }
          
         this.removeUrlSyntax(this.previousUrl)
        }
      )
  }

  removeUrlSyntax(arr){
    let count = 0;
    console.log(arr);
    
   for (let index = 0; index < arr.length; index++) {
    console.log();
    
   if(arr[index]['url'].includes('test/TestSuit')){
    count++;
    if(count>0){
      console.log('arr1',arr);
      
      console.log(arr[index]);
      
    }
   }
    return arr;
   }
  }
  geturlName(url) {
    if (url.includes('/setting/project-setting')) {
      return 'project-setting'
    }
    else if(url.includes('/test/TestStep/')){
        return 'Test-step'
    }
    else if(url.includes('/test/TestSuit')){
      return 'TestCase'
   }
  else if(url.includes('/test/TestStep/')){
    return 'TestStep'
  }
else if(url.includes('/data/manage-test-data')){
  return 'Manage-test-data'
}

  }
  getProjectName() {

    if(JSON.parse(localStorage.getItem('projectDataById'))){
      var res = JSON.parse(localStorage.getItem('projectDataById'));
      this.headerOptions.data = {
        projectId: this.projectId,
        projectName: res['projectName']
      };
      //set header details
      this.homeService.setHeaderOptions(this.headerOptions);
      this.projectData = res;
      this.projectType = this.projectData['projectType'];
    }

   else if(!JSON.parse(localStorage.getItem('projectDataById')))
    {
      this.project.getProjectById(this.projectId).subscribe((
        data => {
          this.projectData = data;
          this.headerOptions.data = {
            projectId: this.projectId,
            projectName: data['projectName']
          };
          //set header details
          this.homeService.setHeaderOptions(this.headerOptions);
          //console.log(this.projectData);
          this.projectType = this.projectData['projectType'];
         
          // this.projectName = this.projectData.projectName
        }
      ))
    }
  }

  getTestCaseData() {

    this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testSuiteData/' + this.projectId + '/' + this.testId).
      subscribe(
        (data) => {
          this.testCassedata = data;
          //console.log(this.testCassedata);
        }
      )
  }


  onTaskPageChange(newValue) {
    this.taskSelectedPage = newValue;
    this.taskPerpageitem = newValue;
  }

  onPreConditonPageChange(newValue) {
    this.preConditionsSelectedPage = newValue;
    this.preConditionsPerpageitem = newValue;
  }

  onIncProcessPageChange(newValue) {
    this.IncProcessSelectedPage = newValue;
    this.IncProcessPerpageitem = newValue;
  }

  loadForm() {
    this.testCaseCreateForm = this.formBuilder.group({
      title: ['',  [
        Validators.required,
        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)
    ]],
      testCaseId: [],
      dataLabels: [],
      comment: [],
      executionIteration: ['1', [
        Validators.required,
        Validators.min(1)
    ]]
    });
    let addNewField = this.ADOCheck ? this.testCaseCreateForm.addControl('adoIntId', this.formBuilder.control('')) : this.testCaseCreateForm.removeControl('adoIntId');

    this.moveTestCaseForm = this.formBuilder.group({
      orderIndex: ['', [
        Validators.required,
        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)
    ]]
    })
  }
  get f() {
    return this.testCaseCreateForm.controls;
  }
  getdataLabel($event) {

  }
  onCreateTestCase() {

    //console.log('CreatetestCase')
    this.submitted = true;
    if (this.testCaseCreateForm.invalid) {
      return;
    }
   
    if(this.testCaseCreateForm.value.title.trim().length == 0)
    {
        this.toastrService.clear();
        this.toastrService.warning("Title field should not be empty");
        return;
    }
    var objFormval = this.testCaseCreateForm.value;
    objFormval.title = this.testCaseCreateForm.value.title.trim()
     if (!/^[^:|*?<>/\\"]+$/.test(this.testCaseCreateForm.value.title)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Case name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }
    //console.log(objFormval);
    // var cancelObj = this.cancelmodal;
    this.testCase.addTestCase(this.projectId, this.testId, objFormval).subscribe((data) => {
      if (data) {
        this.cancelmodal.nativeElement.click();
       
             - this.initTestCaseData();
              this.toastrService.clear();
              this.toastrService.success('New Case Added successfully');
              this.testCaseCreateForm.reset();
              this.project.loadSuggestion.next(true);
            
      }
    });

  }

  onUpdateTestCase() {

  }
  getTitle(title, id) {
    title = title;
    id = id
    //console.log(title);

    this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete ' + title + ' ?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.http.delete(this.url + '/HuLoopRest/huloop/test/' + this.projectId  + '/' + id).subscribe(
            (data) => {

                    this.initTestCaseData();
                    this.toastrService.clear();
                    this.toastrService.success(title + ' deleted successfully');
                    this.project.loadSuggestion.next(true);
                 
            }
          )
        }
      });
  }

  refreshPage() {
    this.document.defaultView.location.reload();
  }

  sendId(id) {
    this.testCaseStep = this.testCassedata.testCaseData.filter((f) => f.id === id);
    // this.testCase.setDataForUpdate(this.testCaseStep)
    //console.log(this.testCaseStep);
    // this.modalService.open(this.editModal);
    // this.openModal();
    this.titleForUpdate = this.testCaseStep[0].title;
    this.testCaseIdForUpdate = this.testCaseStep[0].testCaseId;
    this.dataLabelsForUpdate = this.testCaseStep[0].dataLabels;
    this.commentForUpdate = this.testCaseStep[0].comment;
    this.confirmationDialogService.openFormPopUp(this.testCaseStep)
      .afterClosed().subscribe(res => {
        if (res) {
                 this.initTestCaseData();
                this.toastrService.clear();
                this.toastrService.success('Case updated successfully');
                this.project.loadSuggestion.next(true);

             
        }
        
      });

  }

  // openModal() {
  //   const dialogRef =  this.dialog.open(UpdateFormComponent, { 
  //     data: {name: this.testCaseStep}, disableClose: true});
  //   dialogRef.afterClosed().subscribe((submit) => {

  //   })
  //  }

  onChange(index: string, isChecked: boolean) {

    this.testCassedata.testCaseData.forEach(element => {
      if(element.id ==  index)
      {
        element.checked = isChecked;
      }
    });

    let isAllTestCasesChecked =  true;

    this.testCassedata.testCaseData.forEach(element => {
      if(!element.checked)
      {
        isAllTestCasesChecked = false
      }
    });

    this.testCaseMultiCheck =  isAllTestCasesChecked;


    this.indexFormArray = <UntypedFormArray>this.form.controls.checkArray;

    if (isChecked) {
      this.indexFormArray.push(new UntypedFormControl(index));
      //console.log(this.indexFormArray.value);
      this.enableCopy = true;
      this.enableCut = true;
      if (this.indexFormArray.value.length > 0) {
        this.enableMultiDelete = true;
       
      }
      else {
        this.enableMultiDelete = false;
      }
    } else {
      let Index = this.indexFormArray.controls.findIndex(x => x.value == index)
      this.indexFormArray.removeAt(Index);
      if(this.indexFormArray.value.length<1){
        this.enableCopy = false;
        this.enablePaste = false;
        this.enableCut = false;
      }
      //console.log(this.indexFormArray.value)
      if (this.indexFormArray.value.length > 0) {
        this.enableMultiDelete = true;
      }
      else {
        this.enableMultiDelete = false;
      }
    }

    this.selectedTestIdArray = this.indexFormArray.value;
  }

  onChangPreSteps(index:string, isChecked: boolean) {

    this.testStep.forEach((element, i) => {
      if(i == index)
      {
        element.checked = isChecked;
      }
    });

    let isAllTestCasesChecked =  true;

    this.testStep.forEach(element => {
      if(!element.checked)
      {
        isAllTestCasesChecked = false
      }
    });

    this.preStepsMultiCheck =  isAllTestCasesChecked;


    this.indexFormArray3 = <UntypedFormArray>this.form3.controls.checkArray3;
    this.enableCopy = true;
    this.enableCut = true;
    if(isChecked) {
      this.indexFormArray3.push(new UntypedFormControl(index));
      //console.log(this.indexFormArray3.value);
    } else {
      let Index = this.indexFormArray3.controls.findIndex(x => x.value == index)
      this.indexFormArray3.removeAt(Index);
      if(this.indexFormArray3.value.length<1){
        this.enableCopy = false;
        this.enablePaste = false;
        this.enableCut = false;
      }
      //console.log(this.indexFormArray3.value)
    }
  }
  onCheckTestCase(index: string, isChecked: boolean) {

    this.tableData.forEach((element, i) => {
      if(element.id == index)
      {
        element.checked = isChecked;
      }
    });

    let isAllTestCasesChecked =  true;

    this.tableData.forEach(element => {
      if(!element.checked)
      {
        isAllTestCasesChecked = false
      }
    });

    this.incTestSuiteMultiCheck =  isAllTestCasesChecked;

    this.indexFormArray1 = <UntypedFormArray>this.form1.controls.checkArray;

    if (isChecked) {
      this.indexFormArray1.push(new UntypedFormControl(index));
      //console.log(this.indexFormArray1.value);
    } else {
      let Index = this.indexFormArray1.controls.findIndex(x => x.value == index)
      this.indexFormArray1.removeAt(Index);
      //console.log(this.indexFormArray1.value)
    }
    this.selectedIncludeSuiteIdArray = this.indexFormArray1.value
  }

  onAddTestCases(index: string, isChecked: boolean) {
    this.indexFormArray2 = <UntypedFormArray>this.form2.controls.checkArray;

    if (isChecked) {
      this.indexFormArray2.push(new UntypedFormControl(index));
      //console.log(this.indexFormArray2.value);
      this.isEnabled = true;
    } else {
      let Index = this.indexFormArray2.controls.findIndex(x => x.value == index)
      this.indexFormArray2.removeAt(Index);
      if(this.indexFormArray2.value.length<1){
        this.isEnabled = false;
      }
      
      //console.log(this.indexFormArray2.value);
    }
  }

  removeSeletedTestCases() {
    if (this.selectedIncludeSuiteIdArray == undefined) {
      this.toastrService.clear();
      this.toastrService.warning('Please select suite to delete');
      return;
    }
    if (this.selectedIncludeSuiteIdArray.length < 1) {
      this.toastrService.clear();
      this.toastrService.warning('Please select suite to delete');
      return;
    }
   
    //console.log(this.indexFormArray1.value);
    const list = this.indexFormArray1.value;
    
    this.confirmationDialogService.openConfirmDialog('Are you sure to delete selected suites ?')
      .afterClosed().subscribe(res => {
        if(res){
        list.forEach((element, i) => {
          if (element != null) {
            this.testCase.deleteTestSuite(this.projectId, this.testId, element).subscribe(
              (data) => {
                if (i + 1 == list.length) {
                  this.initTestCaseData();
                  this.unCheckTestSuite = false;
                  this.form1.reset();
                  this.indexFormArray1 = undefined;
                  this.selectedIncludeSuiteIdArray=undefined;
                  this.toastrService.clear();
                  this.toastrService.success(' Deleted successfully');
                }
              }
            );
          }

        })}
        ;
      });
  }

  removeSelectedRows() {
    //console.log(this.selectedTestIdArray);

    if (this.selectedTestIdArray == undefined) {
      this.toastrService.clear();
      this.toastrService.warning('Please select Case to delete');
      return;
    }
    if (this.selectedTestIdArray.length < 1) {
      this.toastrService.clear();
      this.toastrService.warning('Please select Case to delete');
      return;
    }
    const list = this.selectedTestIdArray;
    //console.log(list);
    const objList = {
      list: list
    }

    this.confirmationDialogService.openConfirmDialog('Are you sure ? You want to delete selected cases ?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.http.post(this.url + '/HuLoopRest/huloop/' + 'test/delMultiTestCase/' + this.projectId + '/' + this.testId, objList).subscribe((data) => {

            // this.initTestCaseData()
            this.toastrService.clear();
            this.toastrService.success('Selected Case deleted successfully');
            this.project.loadSuggestion.next(true);
            // this.cancelmodal.nativeElement.click();
            this.list = [];
              let removeArray = this.indexFormArray.value;
                for(let i=0;i<removeArray.length;i++){
                  this.onChange(removeArray[i],false);
                }
                  this.initTestCaseData();
                 
                  this.enableMultiDelete = false;
                  this.selectedTestIdArray = [];

               

          });
        }
      })

    // http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/delMultiTestCase/61276c94a1f486a24017af5e/61276c94a1f486a24017af60
  }

  skipTestCase() {
    if (this.selectedTestIdArray == undefined) {
      this.toastrService.clear();
      this.toastrService.warning('Please select Case to skip/unskip');
      return;
    }

    if (this.selectedTestIdArray.length < 1) {
      this.toastrService.clear();
      this.toastrService.warning('Please select Case to skip/unskip');
      return;
    }
    //console.log(this.indexFormArray.value);
    this.list = JSON.parse(JSON.stringify(this.selectedTestIdArray));

    if(this.list.length > 0)
    {
      this.list.forEach((selectedCase)=>
        {
          if(this.testCassedata['testCaseData'].length > 0)
          {
            this.testCassedata['testCaseData'].forEach(element => {
              if(element.id == selectedCase)
              {
                if (element.active == 'DISABLE') {
                  element.active = 'ENABLE';
                }
                else {
                  element.active = 'DISABLE';
                }
              }
            });
          }
        })
    }

    var list2 = [];
    if(this.testCassedata['testCaseData'].length > 0)
    {
      this.testCassedata['testCaseData'].forEach(element => {
        if(element.active == 'DISABLE')
        {
          list2.push(element.id);
        }
      });
    }

    var objList = {
      list: list2
    }
    //console.log(objList);
    //console.log(this.testId);
    this.http.post(this.url + '/HuLoopRest/huloop/' + 'test/skipTestCase/' + this.projectId + '/' + this.testId, objList).subscribe(
      (data) => {


        // this.cancelmodal.nativeElement.click();
             
              this.toastrService.clear();
              this.toastrService.success('Selected Cases skipped/unskipped successfully.');
              this.initTestCaseData();
              this.list = [];
              let removeArray = this.indexFormArray.value;
                for(let i=0;i<removeArray.length;i++){
                  this.onChange(removeArray[i],false);
                }

      });
  }

  getActive() {

    // if(this.testCassedata.active == 'DISABLE'){
    //   return 'disable'
    // }
    // if(this.testCassedata.active == 'ENABLE'){
    //   return 'active'
    // }
  }

  onContextMenu(event: MouseEvent, testData, index,path) {
  
    event.preventDefault();
    this.pathContextClick = path;
    //console.log(this.pathContextClick);
    
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menuData = { 'item': testData, 'index': index };
    // this.contextMenu.menuData = { 'index': index };
    this.contextMenu.menu.focusFirstItem('mouse');
    this.contextMenu.openMenu();
    //console.log(testData, 'onContext', this.contextMenu.menuData, '>>', index);
  }
  copy(item) {
    //console.log(item);
    this.testCaseCheck = item.parentTestDataId
    this.enableCutFlag=false;
    this.toastrService.clear();
    this.toastrService.success('Selected Case copied successfully');
    this.DataForPaste = item
    this.project.sendCopyData(item, 'copy');

  }
  cut(item) {
    this.testCaseCheck = item.parentTestDataId;
    let suiteCheck = false;
    this.allSuiteList.forEach((element)=>
    {
      if(element.id == this.testCaseCheck && this.allSuiteList.length == 1)
      {
        this.toastrService.clear();
        this.toastrService.warning("There is no other suite to paste the case");
        suiteCheck =  true;
      }
    })

    if(suiteCheck)
    {
      return;
    }

    const modalElement = document.getElementById('pasteTestCase'); // Get the modal element
    if (modalElement) {
      const modal = new Modal(modalElement); // Create a new instance of the Modal class
      modal.show(); // Show the modal
    }

    this.toastrService.clear();
    this.toastrService.success('Selected Case cut successfully');
    this.cutDataForPaste = item
    this.enableCutFlag = true;
    this.project.sendCopyData(item, 'cut');
  }
  move(item) {

    let selectedIndex;
    this.testCassedata.testCaseData.forEach((element, i)=>
    {
      if(element.id == item.id)
      {
        selectedIndex = i;
      }
    })

    this.moveTestCaseForm.reset();
    //console.log(item, index);
    this.CaseMoveEnable = true;
    this.moveIndex = selectedIndex;
    this.Title = item.title
    //console.log(this.Title);
  
    this.sourceIndex = selectedIndex;
    // this.sourceIndex =  this.moveIndex;
    //console.log('source =========>', this.sourceIndex);

  }
  clear() {
    this.CaseMoveEnable = false;
  }

  onMoveTestCase() {
    //console.log('MovetestCase')
    this.submitted = true;
    if (this.moveTestCaseForm.invalid) {
      return;
    }
    var objFormval = this.moveTestCaseForm.value;
    if(parseInt(objFormval.orderIndex) < 1){
      this.toastrService.clear();
      this.toastrService.warning("Enter valid index");
      return;
    }
    //console.log('objFormval', objFormval);
if(parseInt(objFormval.orderIndex)>this.testCassedata.testCaseData.length){
  this.toastrService.clear();
        this.toastrService.warning("Enter valid index");
        return;
}

    // this.orderIndex = (objFormval.orderIndex - 1).toString();
  this.moveTestCase(parseInt(objFormval.orderIndex));
  }

  moveTestCase(moveIndex) {
    var sourceIndex = parseInt(this.sourceIndex);
    var destIndex = moveIndex - 1;
    if (sourceIndex === destIndex) {
        this.toastrService.clear();
        this.toastrService.warning("Source and destination are same");
    } else {
        var oIndex = 0;
        for (var i = 0; i < this.testCassedata.testCaseData.length; i++) {
            if (sourceIndex > destIndex) {
                if (i === destIndex) {
                  this.testCassedata.testCaseData[sourceIndex].orderIndex = oIndex;
                    oIndex++;
                    this.testCassedata.testCaseData[destIndex].orderIndex = oIndex;
                } else if (i !== sourceIndex) {
                  this.testCassedata.testCaseData[i].orderIndex = oIndex;
                }
                oIndex++;
            } else {
                if (i === destIndex) {
                  this.testCassedata.testCaseData[destIndex].orderIndex = oIndex;
                    oIndex++;
                    this.testCassedata.testCaseData[sourceIndex].orderIndex = oIndex;
                    oIndex++;
                } else if (i !== sourceIndex) {
                  this.testCassedata.testCaseData[i].orderIndex = oIndex;
                    oIndex++;
                }
            }
        }
        var testArray = new Array();
        var testSuitesCases = {"testCaseData": testArray};
        for (var i = 0; i < this.testCassedata.testCaseData.length; i++) {
            var tempData = this.testCassedata.testCaseData[i];
            var temp = {
                id: tempData.id,
                orderIndex: tempData.orderIndex,
                projectId: tempData.projectId,
                parentTestDataId: tempData.parentTestDataId
            };
            testArray.push(temp);
        }
        // testSuitSrvice.reOrderTestCase(testSuitesCases).then(function (data) {
        //     $scope.showMoveOptionsinTestCase = false;
        //     if (data.data.testCaseData) {
        //         $scope.loadTestCase();
        //     }
        // });

        this.http.post(this.url + '/HuLoopRest/huloop/test/reorderTestCase/testCases/', testSuitesCases).subscribe(
          (data) => {
           this.closeMoveModal.nativeElement.click();
           this.toastrService.clear();
           this.toastrService.success('Selected Case rearranged successfully')
           
        this.initTestCaseData();
          }
    
        )
    }

};

  exportJunit(item) {
    //console.log(item);
    this.testCase.exportTestCaseAsJunit(item, item.id);
  }
  Association(item) {
    //console.log(item);
    this.compareName = '';
    this.disassociationButton = true;
    this.associationButton = true;
    this.ObjectForAssociation = item;
    //console.log(this.ObjectForAssociation);
    this.enableAssociation = true;
    //console.log(item.testDataSourceName.name);
    this.enableDisassosciationButton = item.testDataSourceName.name;
    // if(this.enableDisassosciationButton==undefined){
    //   this.disassociationButton = true;
    //   console.log(this.disassociationButton);
    // }
    //console.log(this.disassociationButton);
    this.project.getDefaultTextData(this.projectId).subscribe(
      (data) => {
        this.textData = data['textData']
        //console.log(this.textData[0].name);
        this.testDataForAssociation = this.textData.filter((f) => f.name == item.testDataSourceName.name);
        this.compareName = this.testDataForAssociation[0].name;
        //console.log(this.testDataForAssociation);
        if (this.compareName.length > 2) {
          this.disassociationButton = false;
          //console.log('hello');
        }
        else {
          this.disassociationButton = true;
        }
      }
    )

    //  if(){}
  }

  getDefaultTextData() {
    this.testCaseIdFormArray = [];
    this.enableMultiAssociationButton = false;
    this.enableMultiDissociationButton = false;
    
    this.project.getDefaultTextData(this.projectId).subscribe(
      (data) => {
        this.textData = data['textData']
        this.enableMultiAssociation = true;

      }
    )
  }
  moveToSelectedTab(tabName: string) {
    for (let i = 0; i < document.querySelectorAll('.mat-tab-label-content').length; i++) {
      if ((<HTMLElement>document.querySelectorAll('.mat-tab-label-content')[i]).innerText == tabName) {
        (<HTMLElement>document.querySelectorAll('.mat-tab-label')[i]).click();
      }
    }
  }
  // selectedName(){
  //   if(this.testDataForAssociation[0].name){
  //     return 'changeBg'
  //   }
  // else{e
  //   return 'modal-title'
  // }

  // }
  disassociate() {
    this.testDataForAssociation
    //console.log(this.compareName);
    var obj = {
      name: this.testDataForAssociation[0].name,
      settingName: this.testDataForAssociation[0].settingName
    }
    //console.log(obj);
    if (this.ObjectForAssociation.testDataSourceName) {
      this.ObjectForAssociation.testDataSourceName = { runType: "SEQUENTIAL", settingType: "default" };
      //console.log(this.ObjectForAssociation);
      this.testCase.assiciationTestCase(this.projectId, this.ObjectForAssociation.parentTestDataId, this.ObjectForAssociation).subscribe((data) => {
        //console.log(data);
        this.compareName = '';
        this.toastrService.clear();
        this.toastrService.success('Selected data dissociated successfully');
      })

    }

  }
  associateData(name, settingName) {
    console.log(name,settingName);
    
    if (this.compareName == name) {

      this.disassociationButton = false;
      this.associationButton = true;
    }
    else if (this.compareName != name) {

      this.activeState = name;
      this.associationButton = false;
      this.disassociationButton = true;
    }
  this.settingNameForAssociation = settingName;
  this.nameForAssociation = name;
  }

  submitAssoiciatedData() {
    var obj = {
      name: this.nameForAssociation,
      settingType: this.settingNameForAssociation
    }
    console.log(obj);
    
    this.ObjectForAssociation.testDataSourceName = obj;
    this.testCase.assiciationTestCase(this.projectId, this.ObjectForAssociation.parentTestDataId, this.ObjectForAssociation).subscribe((data) => {
      //console.log(data);
      this.compareName = '';
      this.toastrService.clear();
      this.toastrService.success('Selected data associated successfully');
    })
  }

  redirectToTestData(testData) {
    this.testCaseId = testData.id;
    console.log(testData);
    console.log(this.projectId);
    if (this.projectId === undefined) {
      alert('select a project')
    }
    else if (this.projectId) {
      if(testData.testDataSourceName.settingType){
        var settingName = testData.testDataSourceName.settingType
      }
      else{
        settingName = 'default'
      }
      this.router.navigate(['/data/manage-test-data/' + this.projectId],
        {
          queryParams:
          {
            testDataSourceName: testData.testDataSourceName.name,
            testId: this.testId,
            testCaseId: testData.id,
            settingName: settingName
          } 
        });
    }
  }


  selectAll() {
    // let checkBoxes = document.querySelectorAll('.form-check-input');
    // this.checkboxes.forEach((element) => {
    //   element.nativeElement.click();
    // });
    let check = !this.testCaseMultiCheck;

    this.testCassedata.testCaseData.forEach(data => {
      data.checked =  check;
      this.onChange(data.id , check);
    });

    this.testCaseMultiCheck = check

    console.log(this.testCassedata, check);
  }

  selectAllPreSteps(event) {
    // let checkBoxes = document.querySelectorAll('.form-check-input');
    // this.checkboxesPre.forEach((element) => {
    //   element.nativeElement.click();
    // });

    this.testStep.forEach((element,i) => {
      element.checked = event;

      this.onChangPreSteps(i, event);
    });

    this.preStepsMultiCheck = event

  }
  selectAllTestSuites(event) {
    // let checkBoxes = document.querySelectorAll('.form-check-input');
    // this.includedSuitCheckboxes.forEach((element) => {
    //   element.nativeElement.click();
    // });

    this.tableData.forEach((element,i) => {
      element.checked = event;

      this.onCheckTestCase(element.id, event);
    });

    this.incTestSuiteMultiCheck = event
  }

  deselectNewTestSuites() {
    // let checkBoxes = document.querySelectorAll('.form-check-input');
    this.includeNewSuitCheckboxes.forEach((element) => {
      if (element.nativeElement.checked) {
        element.nativeElement.checked = false;
      }
    });
  }


  includedTestCases() {
    this.getAllChildTestDir(this.projectId);
    this.testSuiteFileData = [];
    this.tableData = [];
    if (this.testCassedata.testSuiteFileIData) {
      this.testSuiteFileData = this.testCassedata.testSuiteFileIData;
    }
    console.log("included testsuite res ",this.testSuiteFileData);

    this.testSuiteFileData.forEach((element,i) => {
      element.caseIndex=i;
      let testDataIncludeId = element.testDataIncludeId;
      let obj = {};

      this.testCase.getSuitData(this.projectId, testDataIncludeId).subscribe((res: any) => {
       
        obj['includedTestSuite'] = element.title;
        obj['id'] = element.id;
        obj['index']=element.caseIndex;
        obj['testDataIncludeId'] = element.testDataIncludeId;
        if (res.testCaseData) {
          let arrayList = [];
          res.testCaseData.forEach(element => {
            if(element.branch[0]=='false'){
              arrayList.push(element.title);
            }
          });
          obj['IncludesTestCases'] = arrayList;
        }
        this.tableData.push(obj);
        console.log(this.tableData);
        this.tableData = this.tableData.sort((v1, v2) => v1.index - v2.index).map((v) => v);
        console.log("testing ==", this.tableData);
        for(let i=0;i<  this.tableData.length;i++){
          this.tableData[i].caseIndex = i; 
        }


      })


    })

  }

  deleteRow(caseId) {
    //console.log(caseId);
    this.confirmationDialogService.openConfirmDialog('Do you want to delete ?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.testCase.deleteTestSuite(this.projectId, this.testId, caseId).subscribe(
            (data) => {
              this.initTestCaseData();
              this.toastrService.clear();
              this.toastrService.success(' Deleted successfully');
            }
          );
        }
      });
  }

   includeNewTestSuite() {
    this.deselectNewTestSuites();
    //console.log(this.indexFormArray2.value);
    var list  = []
    list = this.indexFormArray2.value
    // list.forEach((element, i) => {
      //console.log("projectId", this.projectId)
      //console.log("selectedId", element);
      //console.log("testId", this.testId);
      // if (element != null) {
        this.testCase.includeTestSuite(this.projectId, this.testId, list.join()).subscribe((response) => {
          list.forEach((element, i) => {
            this.onAddTestCases(element,false);
          })
          // 
          // if (i + 1 == list.length) {
            this.indexFormArray2 = undefined;
           
            this.initTestCaseData();
            this.deselectNewTestSuites();
            this.form2.reset();
            this.isEnabled = false;
            this.cancelmodalForIncludeTestSuite.nativeElement.click();
            this.toastrService.clear();
            this.toastrService.success(' Suites Included successfully');
          // }
        },error=>{
          list.forEach((element, i) => {
            this.onAddTestCases(element,false);
          })
        }
      )
      // }

    // });
  }
async includeFunction(){
}
  resetIncludeTestSuiteForm() {
    this.indexFormArray2 = undefined;
    this.deselectNewTestSuites();
    this.form2.reset();
  }

  getAllChildTestDir(projectId) {
    const params1 = this.projectId;
    this.includeTestCaseList = [];
    this.allSuiteList = []
if(!JSON.parse(localStorage.getItem('getAllChildTestDirResPonse'))){


    var resp = this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/all/' + projectId).
      subscribe(
        (data) => {
          console.log(data);
          // var data = JSON.parse(localStorage.getItem('getAllChildTestDirResPonse'))
          this.testTreedata = data['testSuiteFileData'];

          this.testTreedata.forEach(element => {
            let obj = {};
            obj['id'] = element.id;
            let moduleName: string = element.path.replaceAll(",", "")
            // obj['path'] =  moduleName.concat("\\", element.title)  ;
           
            if(moduleName==""){
              obj['path'] = element.title;
            }
            else{
              obj['path'] = moduleName + "\\" + element.title;
            }
            this.allSuiteList.push(obj);
            if (element.id != this.testId) {
              this.includeTestCaseList.push(obj);
            }
           
          });
          //console.log(this.includeTestCaseList);
        })
      }
      else{
         var data = JSON.parse(localStorage.getItem('getAllChildTestDirResPonse'))
         this.testTreedata = data['testSuiteFileData'];

         this.testTreedata.forEach(element => {
           let obj = {};
           obj['id'] = element.id;
           let moduleName: string = element.path.replaceAll(",", "")
           // obj['path'] =  moduleName.concat("\\", element.title)  ;
          
           if(moduleName==""){
             obj['path'] = element.title;
           }
           else{
             obj['path'] = moduleName + "\\" + element.title;
           }
           this.allSuiteList.push(obj);
           if (element.id != this.testId) {
             this.includeTestCaseList.push(obj);
           }
          
         });
      }
  }

  isIncludeTestSuiteDisabled(id: string) {
    let check: boolean = false;
    this.tableData.forEach(element => {

      if (element.testDataIncludeId == id) {
        check = true;
      }
    });
    if (check) {
      return true;
    }
    else {
      return false;
    }
  }
  addRow(index) {
    this.testStepAtSelectedIndex = {
      active: "ENABLE",
      commandName: "OPEN",
      comment: "",
      debug: "",
      elementKey: "",
      evaluatedMetaValue: "",
      maskedData: "",
      pageName: "",
      parameters: "",
      result:
      {
        startTime: '0', endTime: '0', duration: '0.0',
        resultState:
        {

        },
        aggrResultState: {

        },
      },
      runState: "",
      testData: "",
      type: "AUTOMATIC",
    }
    if (this.projectType === 'WEB') {
      this.testStepAtSelectedIndex.commandName = 'OPEN';
  } else if (this.projectType === 'DESKTOP') {
    this.testStepAtSelectedIndex.commandName = 'OPENDESKTOPAPP';
  } else if (this.projectType === 'MOBILE') {
    this.testStepAtSelectedIndex.commandName = 'OPENMOBILEAPP';
  } else if (this.projectType === 'MIXED') {
    this.testStepAtSelectedIndex.commandName = 'OPENBROWSER';
  } 
    else if (this.projectType === 'REST') {
      this.testStepAtSelectedIndex.commandName =  'REQ_START';
  } 
  else{
    this.testStepAtSelectedIndex.commandName='OPEN';
  }
    // this.testStepAtSelectedIndex = this.testStep[0];
    //console.log("formTestStep", this.testStepAtSelectedIndex);



    // this.arr = testStepUpdateForm.value;


    // this.testStepAtSelectedIndex.commandName = 'OPEN';
    if (index == 0 && this.testStep == undefined) {


      this.testStep = [];
    }

    // this.testStep = this.testStepdata.teststepList;
    const items = this.testStep;
    //console.log(items);
    const insert = (arr, index, newItem) => [
      // part of the array before the specified index
      ...arr.slice(0, index),
      // inserted item
      newItem,
      // part of the array after the specified index
      ...arr.slice(index)
    ]
    if (index > 0) {
      this.result = insert(items, index, this.testStepAtSelectedIndex);
      //console.log("insert", this.result);
      // this.testStep.push(this.result);
    }
    if (index == 0) {
      //console.log('oo', items);

      this.result = insert(items, 0, this.testStepAtSelectedIndex);
      //console.log("insert", this.result);
      // this.testStep.unshift(this.result);
    }



    var objForAdd =
    {
      id: this.testId,
      projectId: this.projectId,
      teststepList: this.result
    }
    //console.log(objForAdd);

    this.testCase.editTestFileStep(objForAdd).subscribe(
      (data) => {
        //console.log(data);
        localStorage.removeItem('testCassedata');
        this.getTestSuiteData();
        objForAdd['index'] = index;
        const item = {
          index: index + 1,
          id: this.testId,
          projectId: this.projectId,
          parentId: this.testId,
          // testStepId:this.
          stepForUpdate: items
        }//openUpdatePopUp(item,this.testStepdata.path)
        this.confirmationDialogService.openUpdatePopUp(item, this.testCassedata.path,'pre-condition','Add')
          .afterClosed().subscribe(res => {
            if (res) {
              localStorage.removeItem('testCassedata');
              this.getTestSuiteData();
              this.toastrService.clear();

              this.toastrService.success('Step added successfully')

            }
          });
      }
    )
  }
  addFileStep() {
    this.addRow(0)
    // this.testCase.editTestFile(payload)
  }
  updateTestStep(index,commandName?:any) {
    const item = {
      index: index + 1,
      id: this.testId,
      projectId: this.projectId,
      parentId: this.testId,
      pseCommand:commandName
      // stepForUpdate:items
    }
    //console.log(item, this.testCassedata.path);
    this.confirmationDialogService.openUpdatePopUp(item, this.testCassedata.path,'pre-condition','Edit')
      .afterClosed().subscribe(res => {
        if (res) {
          localStorage.removeItem('testCassedata');
          this.getTestSuiteData();
          this.toastrService.clear();
          this.toastrService.success("Step updated successfully at " + item.index++  + "index");

        }
      });
  }
  deleteStep(Index) {
   
    
    this.stepsTobeDelete = this.testStep[Index];
    //console.log('>>', this.stepsTobeDelete);
    const IndexMsg = JSON.parse(JSON.stringify(Index)) + 1;
    this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete ' + IndexMsg+ ' index record ?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.filterArr();
          this.toastrService.clear();
          this.toastrService.success(' Step Deleted successfully');
        }
      });
  }
  filterArr() {
    //console.log(this.testStep.length);
    this.initiateDelTestStep = this.testStep;

    for (var i = 0; i < this.initiateDelTestStep.length; i++) {

      if (this.initiateDelTestStep[i] === this.stepsTobeDelete) {

        this.initiateDelTestStep.splice(i, 1);
      }

    }
    //console.log(this.testStep);
    var objForDelete =
    {
      id: this.testId,
      projectId: this.projectId,
      teststepList: this.testStep
    }
    this.testCase.editTestFileStep(objForDelete).subscribe(
      (data) => {
        //console.log(data);
        localStorage.removeItem('testCassedata');
        this.getTestSuiteData();
      }
    )
  }

  toggleManual(i){
    //console.log(this.testStep[i])
    if(this.testStep[i].type=='MANUAL'){
      this.testStep[i].type='AUTOMATIC';
    }
    else{
      this.testStep[i].type='MANUAL';
    }
    //console.log(this.testStep);
    var objForUpdate =
    {
      id: this.testId,
      projectId: this.projectId,
      teststepList: this.testStep
    }
    this.testCase.editTestFileStep(objForUpdate).subscribe(
      (data) => {
        //console.log(data);
        localStorage.removeItem('testCassedata');
        this.getTestSuiteData();
      }
    )
  }
  insertComment(stepIndex){
    this.testStepIndexForInsert = stepIndex;
    this.stepIndexForInsertComment = this.testStep[stepIndex];
    this.typeCheck=this.stepIndexForInsertComment.type;
    this.valueForUpdate = this.stepIndexForInsertComment.comment;
     }
     enableSubmitBUtton(value){
      if(this.valueForUpdate != value){
        this.enableBUtton = false;
        
          }
          else{
            this.enableBUtton = true;
          }
    }
  onSubmit(insertCommentForm){
  
    this.formObj = insertCommentForm.value;
    this.stepIndexForInsertComment.comment = Object.values(this.formObj)[0];
   //console.log(this.stepIndexForInsertComment);
   //console.log(this.testStep);
   this.cancelmodalforcomment.nativeElement.click();
   this.toastrService.clear();
   this.toastrService.success('comment added successfully');
   insertCommentForm.reset();
   var objForUpdate =
   {
     id: this.testId,
     projectId: this.projectId,
     teststepList: this.testStep
   }
   this.testCase.editTestFileStep(objForUpdate).subscribe(
     (data) => {
       //console.log(data);
       localStorage.removeItem('testCassedata');
       this.getTestSuiteData();
     }
   )
  }
  getTestSuiteData() {
    if(!JSON.parse(localStorage.getItem('testCassedata'))){
      this.testCase.getTestSuiteData(this.projectId, this.testId).subscribe(
        (data) => {
          this.suiteData = data;
          console.log('suite>>',this.suiteData);
          
          this.sPath=this.suiteData['path'];
          if(this.suiteData['teststepList']){
            this.testStep = this.suiteData['teststepList']
            for(let i=0;i<  this.testStep.length;i++){
              this.testStep[i].caseIndex = i; 
            }
          }
         
          else{
            this.testStep=[]
          }
         
  
          //console.log('suiteData', this.suiteData, this.testStep);
  
        }
      )
    }
    else if(JSON.parse(localStorage.getItem('testCassedata'))){
      this.suiteData = JSON.parse(localStorage.getItem('testCassedata'));
      console.log('suite>>',this.suiteData);
      this.sPath=this.suiteData['path'];
      if(this.suiteData['teststepList']){
        this.testStep = this.suiteData['teststepList']
        for(let i=0;i<  this.testStep.length;i++){
          this.testStep[i].caseIndex = i; 
        }
      }
     
      else{
        this.testStep=[]
      }
     
    }
  
  }
  getTxtData(text) {
    this.selectedAllFlag = false;
    this.textDataId = text.id;
    this.textDataName = text.name;
    this.textDataSettingType =  text.settingType;
    if(this.textDataSettingType == undefined)
    {
      this.textDataSettingType = text.settingName;
    }
    var testDataArray = this.testCassedata.testCaseData.filter((f) =>
    {
      let check = f.testDataSourceName && f.testDataSourceName.name == this.textDataName && f.testDataSourceName.settingType == this.textDataSettingType?  true : false;
      return check;
    });
    this.testIdArray = [];
    if (testDataArray.length > 0) {
      for (let i = 0; i < testDataArray.length; i++) {
        this.testIdArray.push(testDataArray[i].id)
      }
      if (this.testIdArray.length > 0) {
        this.enableMultiAssociationButton = false;
        this.enableMultiDissociationButton = true;
      }
      //console.log(this.testIdArray);
    }
    else
    {
      this.enableMultiAssociationButton = false;
      this.enableMultiDissociationButton = false;
    }


    this.moveToSelectedTab('Tasks')
  }
  captureTestId(id: string, isChecked: boolean) {
    //console.log(id);
    // this.testIdArray = [];


    if (isChecked) {
      this.testCaseIdFormArray.push(id);
      // console.log(this.testCaseIdFormArray.value);
      if (this.textDataId && this.testCaseIdFormArray) {
        this.enableMultiAssociationButton = true;
        //console.log('ifCheck');

      }
      if (this.testIdArray.length > 0) {
        //console.log('enable testArray');
        var testCaseIdArrayCopy = this.testCaseIdFormArray.concat(this.testIdArray)
        testCaseIdArrayCopy = this.testCaseIdFormArray
        // this.testCaseIdFormArray.value = this.testCaseIdFormArray.value.concat(this.testIdArray)
        // this.testIdArray.push(this.testCaseIdFormArray.value)
      }
      //console.log(this.testCaseIdFormArray.value);
    } else {
      let Index = this.testCaseIdFormArray.findIndex(x => x.value == id)
      //console.log(this.testCaseIdFormArray.controls);

      this.testCaseIdFormArray.splice(Index, 1);
      if (this.testIdArray.length > 0) {
        var testCaseIdArrayCopy = this.testCaseIdFormArray.concat(this.testIdArray)
        testCaseIdArrayCopy = this.testCaseIdFormArray
        // this.testCaseIdFormArray.value = this.testCaseIdFormArray.value.concat(this.testIdArray)
      }

      //console.log(this.testCaseIdFormArray.value)

      if (this.textDataId && this.testCaseIdFormArray) {
        this.enableMultiAssociationButton = true;
        if (this.testIdArray.length == this.testCaseIdFormArray.length) {
          //console.log('true');

          this.enableMultiAssociationButton = false;
          //console.log(this.enableMultiAssociationButton);

        }
      }
      // else{
      //   this.enableMultiAssociationButton = false;
      // }
      if (this.testCaseIdFormArray.length < 1) {
        this.enableMultiAssociationButton = false;
      }
    }

  }

  multiAssociation() {
    // if(this.testIdArray.length){
    //   var list = {
    //     list:this.testIdArray
    //   }   
    // }
    // else{

    var testDataArray = this.testCassedata.testCaseData.filter((f) =>
    {
      let check = f.testDataSourceName && f.testDataSourceName.name == this.textDataName && f.testDataSourceName.settingType == this.textDataSettingType?  true : false;
      return check;
    });

    let data = [];
    testDataArray.forEach((element)=>
    {
      data.push(element.id)
    })

    this.testCaseIdFormArray.forEach(element => {
        data.push(element);
    });
    
    var list = {
      list: data
    }
    // }

    this.testCase.multiAssociation(this.projectId, this.testId, this.textDataId, list).subscribe(
      (data) => {
        //console.log(data);
        this.initTestCaseData();
        this.toastrService.clear();
        this.toastrService.success('Data is associated with the cases')
      }
    )

  }
  enableAssociations() {
    //console.log('Ass Clicked prog.');

    this.showAssociationButton = true;
    this.showDissociationButton = false;
  }
  enableDissociations() {
    this.showAssociationButton = false;
    this.showDissociationButton = true;

  }
  selcetAllAssociated() {
    this.associatedTestCaseData = this.testCassedata.testCaseData.filter((f) => Boolean(f.testDataSourceName.name));
    //console.log(this.associatedTestCaseData);
    this.selectedAllFlag = true;

  }
  multiDissociation() {
    if (this.testIdArray.length > 0) {
      var list = {
        list: this.testIdArray
      }
      //console.log(list);
      this.testCase.multiDissociation(this.projectId, this.testId, list).subscribe(
        (data) => {
          //console.log(data);
          this.initTestCaseData();
          this.toastrService.clear();
          this.toastrService.success('Data is dissociated with the cases')
        }
      )
    }
  }

  resetSeleniumModel()
  {
    this.seleniumFileName = "";
    this.seleniumFile = undefined;
    this.enableseleniumButton=false;
  }
  uploadSeleniumData(event : any)
  {
    this.enableseleniumButton=true;
    //console.log(event);
   this.seleniumFile  = event.target.files[0];
   this.seleniumFileName =  this.seleniumFile.name.substring(0, this.seleniumFile.name.lastIndexOf('.'));
  }
  onImportSeleniumFile()
  {
    if(this.seleniumFile == undefined)
    {
        return;
    }
    
    var fd = new FormData();
    fd.append('file', this.seleniumFile);

    this.http.post(this.url+'/HuLoopRest/huloop/testImport/uploadSelenium/' + this.projectId + "/" + this.testId, fd).subscribe((res)=>
    {
      this.resetSeleniumModel();
      this.toastrService.success("  Selenium file uploaded successfully");
      this.cancelSeleniumDataScreen.nativeElement.click();

      this.initTestCaseData();
    });

  }
  manageLocator(screenName, index){

    //console.log(screenName, index, this.testStep[index]['elementKey']);
   this.setting.seletedScreenName.next(this.testStep[index]['elementKey']);
    this.project.getAllChildLocatorDir(this.projectId).subscribe(
      (data)=>{
      //console.log(data);
  this.testDataForManangeLocator = data['locatorSuite'].filter((f)=> f.name == screenName);
  if(this.testDataForManangeLocator[0]){
    this.project.sendLocatorDataFromTestStep(true);
    this.router.navigate(['/locator/'+ this.projectId+ '/' +this.testDataForManangeLocator[0].id],
  {
    queryParams :
    {
      index : index
    }
  });
  }
  else{
    this.toastrService.clear();
    this.toastrService.info('No locator is associated with this step');
  }
      }
    )
  }
  clearHighLight(selectedIndex){
    this.testStep[selectedIndex].result.resultState.status = 'NOTRUN';
    this.testStep[selectedIndex].result.resultState.notRunCount = 1;
    this.testStep[selectedIndex].result.resultState.modifiedCount = 0;
    //console.log(this.testStep);
    const updateTestStepData = this.suiteData;
    //console.log(updateTestStepData);
    const myObject = updateTestStepData;
    this.testCase.editTestFileStep(updateTestStepData).subscribe(
      (data) => {
        //console.log(data);
        localStorage.removeItem('testCassedata');
        this.getTestSuiteData();
        
      }
    )
  }
  copySelectedTestStep(){
    if(this.indexFormArray3===undefined ){
      this.toastrService.clear();
      this.toastrService.warning( 'Select atleast one  step to copy');
      //console.log('udefined',this.indexFormArray3);
  
      return;
    }
  else if(this.indexFormArray3.value.length < 1){
      //console.log('empty',this.indexFormArray3.value);
      this.toastrService.clear();
      this.toastrService.warning( 'Select atleast one  step to copy');
      return;
    }
    this.testStepArray = {
      // id:JSON.parse(JSON.stringify(this.testStepId)),
      teststepList:[] };

      this.enablePaste = true;
      this.enableCopyCheck=true;
      this.enableCutPaste = false;
      for(let i=0;i<this.indexFormArray3.value.length;i++){
      this.testStepArray.teststepList.push(this.testStep[this.indexFormArray3.value[i]]);
      }
      //console.log(this.testStepArray.teststepList);
      if(!this.agentCheck){
        localStorage.setItem('copiedTestStep',JSON.stringify(this.testStepArray));
      }
     else{
      this.memoryService.setCopiedObj(this.testStepArray)
     }
     //console.log(localStorage.getItem('copiedTestStep'));
     
      this.toastrService.clear();
      this.toastrService.success('Selected step copied successfully')
  }

  cutTestSteps(source){
    if(this.indexFormArray3===undefined ){
      this.toastrService.clear();
      this.toastrService.warning( 'Select atleast one  step');
      return;
    }
  else if(this.indexFormArray3.value.length < 1){
      this.toastrService.clear();
      this.toastrService.warning( 'Select atleast one  step');
      return;
    }
  this.cutTestStepArray = {list:
    this.indexFormArray3.value
  }

if(!this.agentCheck){
  localStorage.setItem('cutTestStepData', JSON.stringify(this.cutTestStepArray));
    localStorage.setItem('sourceId', source); 
}
else{
  this.memoryService.setCutObj(this.cutTestStepArray);
  this.memoryService.setSourceId(source);
}
  // console.log(this.cutTestStepArray)
  this.enableCutPaste = true;
  this.enableCopy=false;
  this.enablePaste=false;
  this.enableCopyCheck=false;
  this.toastrService.clear();
  this.toastrService.info('Selected  step cut successfully')
  ////console.log(this.cutTestStepArray);
  
  }
  
 pasteStep(index){
  //console.log(this.testStepArray)
  var copiedSteps;
  if(!this.agentCheck){
   copiedSteps = localStorage.getItem('copiedTestStep');
  }
  else{
    this.memoryService.getCopiedObj().subscribe(
      (copy)=>{
       copiedSteps = copy;
      }
    )
  }
  //console.log();
  
  if(copiedSteps){
    //console.log(JSON.parse(copiedSteps));
  }
    this.testCase.pasteSteps(this.projectId,this.testId,this.testId,index,JSON.parse(copiedSteps)).subscribe(
      (data)=>{
        //console.log(data);
        this.enableCopy=false;
        this.enableCut=false;
        this.enablePaste=false;
        this.enableCopyCheck=false;
        if(!this.agentCheck){
          localStorage.removeItem('copiedTestStep');
          localStorage.removeItem('testCassedata');
        }
       else{
        this.memoryService.setCopiedObj(null);
       }
        this.getTestSuiteData();
        let removeArray = this.indexFormArray3.value;
                for(let i=0;i<removeArray.length;i++){
                  this.onChangPreSteps(removeArray[i],false);
                }
       
      })
  }
  cutPaste(index){
    // var cutTestStepData = localStorage.getItem('cutTestStepData');
    // var sourceId1 = localStorage.getItem('sourceId').toString();
    var cutTestStepData;
    var sourceId1;
    if(!this.agentCheck){
    cutTestStepData = localStorage.getItem('cutTestStepData');
    sourceId1 = localStorage.getItem('sourceId').toString();
    }
    else{
    this.memoryService.getCutObj().subscribe(
      (cut)=>{
        cutTestStepData = cut;
      }
    )
    this.memoryService.getSourceId().subscribe(
      (sourceId)=>{
        sourceId1 = sourceId.toString();
      }
    )
    }
    this.testCase.cutPaste(this.projectId,sourceId1,this.testId,index,JSON.parse(cutTestStepData)).subscribe(
      (data)=>{
        if(!this.agentCheck){
          localStorage.removeItem('cutTestStepData');
          localStorage.removeItem('sourceId');
        }
        else{
          this.memoryService.setCutObj(null);
          this.memoryService.setSourceId(null);
        }
        this.enableCutPaste = false;
        //console.log(data)
        this.enableCopy=false;
        this.enableCut=false;
        if(sourceId1==this.testId){
          let removeArray = this.indexFormArray3.value;
          for(let i=0;i<removeArray.length;i++){
            this.onChangPreSteps(removeArray[i],false);
          }
        }
        if(!this.agentCheck){
          localStorage.removeItem('testCassedata');
        }
       
        this.getTestSuiteData();
      }
    )
      }

      removeSelectedPreSteps() {

        if(this.indexFormArray3===undefined ){
          this.toastrService.clear();
          this.toastrService.warning( 'Select atleast one  step');
          //console.log('udefined',this.indexFormArray);
    
          return;
        }
      else if(this.indexFormArray3.value.length < 1){
          //console.log('empty',this.indexFormArray3.value);
          this.toastrService.clear();
          this.toastrService.warning( 'Select atleast one  step');
          return;
        }
        else if(this.indexFormArray3.value.length > 0){
          //console.log('empty',this.indexFormArray3.value);
          
          // this.testStepdata.teststepList.filter(value => JSON.stringify(value) !== '{}');
         
          this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete selected steps ?')
            .afterClosed().subscribe(res => {
              if (res) {
                let removeArray = this.indexFormArray3.value;
    
          removeArray = removeArray.sort((a,b) =>  a - b)
          for (let i = 0; i < removeArray.length ; i++){
           var temp;
            removeArray[i];
            temp = removeArray[i];
            //console.log(temp);
            this.testStep[temp]={};
           }
           this.testStep = this.testStep.filter(value => JSON.stringify(value) !== '{}');
          //console.log(this.testStep);

          this.suiteData['teststepList'] = this.testStep;
               this.testCase.editTestFileStep(this.suiteData).subscribe(
                (data)=>{
                  for(let i=0;i<removeArray.length;i++){
                    this.onChangPreSteps(removeArray[i],false);
                  }
                  this.toastrService.clear();
                  this.preStepsMultiCheck = false;
                  this.toastrService.success('Selected steps deleted successfully');
                  localStorage.removeItem('testCassedata');
                  this.getTestSuiteData();
                }
               )
              }
            });
        }
    
    
      }


skipSelectedRows() {
        if(this.indexFormArray3===undefined){
          this.toastrService.clear();
          this.toastrService.warning( 'Select atleast one  step');
          return;
    
        }
    
        if(this.indexFormArray3.value.length < 1){
          this.toastrService.clear();
          this.toastrService.warning( 'Select atleast one  step');
          return;
        }
        let removeArray = this.indexFormArray3.value;
    
        removeArray = removeArray.sort((a,b) =>  a - b)
      //console.log(removeArray);
      //console.log(removeArray.length)
       //console.log(this.testStepdata);
      //  for (var i = 0; i < this.testStep.length; i++) {
        for (let i = 0; i < removeArray.length ; i++){
         var temp;
          removeArray[i];
          temp = removeArray[i];
    
          if(this.testStep[temp].active=='DISABLE'){
            this.testStep[temp].active='ENABLE';
            //console.log( this.testStep[temp])
          }
          else {
            this.testStep[temp].active='DISABLE';
            //console.log( this.testStep[temp]);
          }
         }
        //console.log(this.suiteData);
    
       this.testCase.editTestFileStep(this.suiteData).subscribe((data)=>{

        for(let i=0;i<removeArray.length;i++){
          this.onChangPreSteps(removeArray[i],false);
        }
        localStorage.removeItem('testCassedata');
        this.getTestSuiteData();
        this.toastrService.clear();
        this.toastrService.success( 'Selected Step(s) Skipped/Unskipped Successfully');
       })
      }

      addSteps(stepId){
        //console.log(this.testCassedata.testCaseData[0].id);
        this.testStepAtSelectedIndex = {
          active: "ENABLE",
          commandName: "OPENBROWSER",
          comment: "",
          debug: "",
          elementKey: "",
          evaluatedMetaValue: "",
          maskedData: "",
          pageName: "",
          parameters: "",
          result:
          {
            startTime: '0', endTime: '0', duration: '0.0',
            resultState:
            {
      
            },
            aggrResultState: {
      
            },
          },
          runState: "",
          testData: "",
          type: "AUTOMATIC",
        }
      
        // this.testStepAtSelectedIndex = this.testStep[0];
        //console.log("formTestStep", this.testStepAtSelectedIndex);
        this.testStep = [];
        
        
        // this.testStep = this.testStepdata.teststepList;
        const items = this.testStep;
        //console.log(items);
        const insert = (arr, index, newItem) => [
          // part of the array before the specified index
          ...arr.slice(0, index),
          // inserted item
          newItem,
          // part of the array after the specified index
          ...arr.slice(index)
        ]
      
      
        //console.log('oo',items);
        
        this.result = insert(items, 0, this.testStepAtSelectedIndex);
        //console.log("insert", this.result);
        // this.testStep.unshift(this.result);
      
      
       
       
        var objForAdd=
        {
      id:this.testId,
      projectId:this.projectId,
      teststepList:this.result
        }
        //console.log(objForAdd);
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + stepId).
        subscribe(
          (data) => {
            this.testStepdata = data;
            //console.log(this.testStepdata);
            this.testStepdata['teststepList'] = this.result;
          //console.log("Create", this.result);
          const createTestStepData = this.testStepdata;
          //console.log(createTestStepData);
            
            this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', createTestStepData).
            subscribe(
              (data)=>{
                //console.log(data);
                //console.log("upDateData", data);
                this.testStepdata = data;
                const item = {
                  projectId: this.projectId,
                    parentId:this.testStepdata['parentTestDataId'], 
                    testStepId:this.testStepdata['id'],
                    index: 1
                 }
                 //console.log(item);
          //console.log('Updaaateee')
          this.confirmationDialogService.openUpdatePopUp(item,this.testStepdata['path'])
          .afterClosed().subscribe(
            (res)=>{
           if(res){
             //console.log(res);
            //  this.router.navigate(['/data/manage-test-data/' + this.projectId])
             //'/test/TestStep', testData.projectId, testData.parentTestDataId, testData.id
             this.router.navigate(['/test/TestStep/'+ this.testCassedata.testCaseData[0].projectId + '/'+ this.testCassedata.testCaseData[0].parentTestDataId + '/'+stepId])
           }
            }
          )
          
          
          })
          })

      }

      movePreStep(item,index){
        // this.moveTestStepForm.reset();
        //console.log(item, index);
        this.StepMoveEnable = true;
        this.movePreStepIndex = index;
        this.sourcePreStepIndex = this.movePreStepIndex;
      
      }
   
      onMove(){
        //console.log('MovetestCase')
      
        this.submitted = true;
        if(this.moveTestStepForm.invalid){
          return;
        }
        var objFormval = this.moveTestStepForm.value;
      
        this.orderPreStepsIndex = (objFormval.orderIndex - 1);
        //console.log(this.orderIndex)
        if (this.orderPreStepsIndex < 0) {
          this.toastrService.clear();
          this.toastrService.warning('index must not be out side the scope');
          return;
        }
        if(this.orderPreStepsIndex == this.sourcePreStepIndex){
          this.toastrService.clear();
          this.toastrService.warning( 'source and destination index must not be same');
          return;
        }
        var lengthCheck = (this.testStep.length - 1);
        if(this.orderPreStepsIndex  > lengthCheck){
          this.toastrService.clear();
          this.toastrService.warning( 'index must not be out side the scope');
          return;
        }
      //console.log(this.testStep.length);
      
      
        [this.testStep[this.sourcePreStepIndex], this.testStep[this.orderPreStepsIndex]] = [this.testStep[this.orderPreStepsIndex], this.testStep[this.sourcePreStepIndex]];
      
        //console.log(this.testStepdata);
        this.testCase.editTestFileStep(this.suiteData).subscribe((data) => {
            if (data) {
              //console.log("upDateData", data);
              this.toastrService.clear();
                 this.toastrService.success( ' Step moved successfully');
                 this.closeMovePreStepModal.nativeElement.click();
                 localStorage.removeItem('testCassedata');
                 this.getTestSuiteData();

              //  this.testStepdata=data;
              //  this.router.navigate(['/TestStep/'+ this.projectId+ '/' +this.testId+ '/'+this.testStepId ]);
            }
          });
      }
    disableImportButton(){
      this.enbleTestCase = false;
    }
    enableImportButton(){
      this.enbleTestCase = true;
    }

    sendSuiteDataToHighLight(projectId,suiteId,projectName,moduleName){
      // console.log(this.tableData);
     //  console.log('p',projectName, 'm',moduleName);
       let values = moduleName.split('\\')
       let body = {
          projectId : projectId,
          projectName : projectName,
          moduleName : values[0],
          suiteName : values[1],
          suiteId : suiteId
       }
       this.project.sendTestSuiteData(body);
      //  this.router.navigate(['/test/TestSuit/'+ projectId + '/'+ suiteId]);
    }
    reloadComponent() {
      let currentUrl = this.router.url;
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          // this.testCase.setSelectedData([]);
          // this.router.navigate([currentUrl]);
      }
    ngAfterViewInit(){
      // this.spinner.isLoading.next(false);
      this.route.queryParams.subscribe((data) => {
        this.selectedTestCaseId = data.testCaseId;
        setTimeout(() => {
          this.selectedTestCaseId = undefined;
        }, 3000)
      })
    }

    ngAfterContentChecked() {
      // console.log('ngAfterContentInit - wrapper', this.testCassedata);
      // if(this.testCassedata==undefined){
      //   this.spinner.isLoading.next(true);
      // }
      // else{
      //   this.spinner.isLoading.next(false);
      // }
    }
    showDropdown(){
      $('.hl-chooseCatogeryWrapper').addClass('show');
    }
    closeDropdown(){
      $('.hl-chooseCatogeryWrapper').removeClass('show');
    }
    desableCardView() {
      this.testCase.setView(false)
      this.changeDefaultView(false)
     this.testCase.getView().subscribe(
        (data)=>{
          this.cardView = data;
        }
      );
    }
    changeDefaultView(event)
  {
    this.userManagement.updateDefaultView(event).subscribe((res)=>
    {
      localStorage.removeItem('currentUser')
      this.toastrService.clear();
      this.toastrService.success("Default view updated successfully");
      this.loadUser();
    })
  }
    enableCardView() {
      this.testCase.setView(true)
      this.changeDefaultView(true)
      this.testCase.getView().subscribe(
        (data)=>{
          this.cardView = data;
        }
      );
    }
    // captureTestIdForPaste(data){
    //     this.testIdForPaste = data.id;
    //     this.isPasteEnabled = true;
 
    // }
    captureTestIdForPaste(id: string, isChecked: boolean) {
      this.pasteFormArray = <UntypedFormArray>this.pasteForm.controls.checkArray;
  
      if (isChecked) {
        this.pasteFormArray.push(new UntypedFormControl(id));
        console.log(this.pasteFormArray);
        this.testIdForPaste = this.pasteFormArray.value;
        this.isPasteEnabled = true;
      } else {
        let Index = this.pasteFormArray.controls.findIndex(x => x.value == id)
        this.pasteFormArray.removeAt(Index);
        // this.isEnabled = false;
        this.testIdForPaste = this.pasteFormArray.value;
        console.log(this.pasteFormArray);
      }
    }
    pasteTestCase() {
        
          if(this.enableCutFlag){
            this.cutPasteTestCase()
          }
          else{
            const obj = {
              id: this.DataForPaste.id,
            };
          this.testIdForPaste.forEach((element,i )=> {
            this.project.copyTestCase(this.projectId, element, obj.id, this.options)
            .subscribe((data) => {
              // this.captureTestIdForPaste(element, false)
              this.pasteFormArray.removeAt(i);
              if(i==this.testIdForPaste.length-1){
                this.isPasteEnabled = false;
                // this.pasteFormArray=undefined;
                this.initTestCaseData();
                this.cancelmodalForPasteCase.nativeElement.click();
                this.toastrService.clear();
                this.toastrService.success("Case pasted successfully");
              }
              
         
            });
          });
            
          }
         
         
        }
  cutPasteTestCase() {
          //console.log(testId);
          //console.log(this.pasteData);
          const obj = {
            id: this.cutDataForPaste.id,
          };
          this.testIdForPaste.forEach((element,i )=> {
          this.project
            .moveTestCase(
              this.cutDataForPaste.projectId,
              this.cutDataForPaste.parentTestDataId,
              element,
              obj.id
            )
            .subscribe((data) => {
              //console.log(data);
              if(i==this.testIdForPaste.length-1){
    
              this.initTestCaseData();
              this.enableCutFlag = false;
              this.cancelmodalForPasteCase.nativeElement.click();
              this.toastrService.clear();
              this.toastrService.success("Case pasted successfully");
              // window.location.reload(); // add by surendra
      
              //  this.getAllChildTestDir(this.projectId);
              }
            });
          });
        }

  encrypParameter(stepIndex) {
    var encryptObj = {
      projectId: this.projectId,
      id: this.testId,
      stepIndex: stepIndex
    }
    this.testCase.encryptTestStepParam(this.projectId, this.testId, stepIndex, encryptObj).subscribe(
      (data) => {
        this.testStepdata = data;
        this.toastrService.clear();
        this.toastrService.success('Data Encryted Successfully;')
        localStorage.removeItem('testCassedata');
        this.getTestSuiteData();
      }
    )
  }

  decrypParameter(stepIndex) {
    var encryptObj = {
      projectId: this.projectId,
      id: this.testId,
      stepIndex: stepIndex
    }
    this.testCase.decryptTestStepParam(this.projectId, this.testId, stepIndex, encryptObj).subscribe(
      (data) => {
        this.testStepdata = data;
        this.toastrService.clear();
        this.toastrService.success('Data decryted Successfully;');
        localStorage.removeItem('testCassedata');
        this.getTestSuiteData();
      }
    )
  }
  checkTestData(value){
  this.textData.forEach(element => {
    if(element.name==value){
      return true;
    }
    else {
      return false;
    }
  });
  
  }
    ngOnDestroy(){
      console.log('ngOnDestroy');
      this.testCassedata = undefined;
      
      // this.spinner.isLoading.next(false);
      
      this.reloadComponent();
    }


    enableRuntimeTestStep(stepIndex) {
      var runtimeObj = {
        projectId: this.projectId,
        id: this.testId,
        stepIndex: stepIndex
      }
      this.testCase.runtimeTestStep(this.projectId, this.testId, stepIndex, runtimeObj).subscribe(
        (data) => {
          
          console.log('data',data);
          this.testStepdata = data;
          var stepData = this.testStepdata['teststepList']
          if(stepData[stepIndex].runtimeData==='true'){
            this.toastrService.clear();
            this.toastrService.success('Runtime parameter active')
          }else{
            this.toastrService.clear();
            this.toastrService.success('Runtime parameter deactive')
          }
          localStorage.removeItem('testCassedata');
          this.getTestSuiteData();
        }
      )
    }

    checkCase(item)
    {
      console.log(item);
    }
}